import {Component, OnInit, ViewChild} from '@angular/core';
import {ExcRestService} from 'exc-rest';
import {ExcCoreModule, ExcTranslation} from 'exc-core';
import {ExcTab, IExcTab} from 'exc-tab';
import {ExcListConfig} from 'exc-controls';
import {ExcProgbarData} from '../app-exc-progbar/app-exc-progbar.component';
import {ExcIndicatorData} from '../app-exc-indicator/app-exc-indicator.component';
import {ModalNewAuditComponent} from '../modals/modal-new-audit/modal-new-audit.component';
import {ModalDealerEditComponent} from '../modals/modal-dealer-edit/modal-dealer-edit.component';
import {DatePipe, CurrencyPipe} from '@angular/common';
import {DefaultSettingsService} from '../default-settings-service.service';
import {ExcSigninService} from 'exc-signin';
import {AuditReviewComponent} from '../audit-review/audit-review.component';
import {ModalReviewFinsihComponent} from '../modals/modal-review-finsih/modal-review-finsih.component';
import {ModalYesNoComponent} from '../modals/modal-yes-no/modal-yes-no.component';
import {AuditActionService} from '../audit-action-service.service';
import {ModalCancelAuditComponent} from '../modals/modal-cancel-audit/modal-cancel-audit.component';
import {ModalAuditCancelComponent} from '../modals/modal-audit-cancel/modal-audit-cancel.component';
import {ModalGeofenceAddComponentComponent} from '../modals/modal-geofence-add-component/modal-geofence-add-component.component';
import {ModalEditSelfcheckComponent} from '../modals/modal-edit-selfcheck/modal-edit-selfcheck.component';
import {ModalAssignAuditComponent} from '../modals/modal-assign-audit/modal-assign-audit.component';
import {ClientModalAuditCancelComponent} from '../client/modals/client-modal-audit-cancel/client-modal-audit-cancel.component';
import {ExcReport, ReportService} from '../report-service.service';
import {ExcFileItem} from '../attachments/models/ExcFileItem';
import {
  DataImportUploadConfirmModalComponent
} from '../data-import-upload-confirm-modal/data-import-upload-confirm-modal.component';
import {element} from 'protractor';
@Component({
  selector: 'app-audit-details',
  templateUrl: './audit-details.component.html',
  providers: [CurrencyPipe, DatePipe],
  styles: []
})
export class AuditDetailsComponent extends ExcTranslation implements OnInit, IExcTab {
  @ViewChild('menuPopup') menuPopup;
  Data: any;
  data = {Header: {} as any, Inventory: [], Charts: [], Attachments: [], Results: [], ProgBarReview: [], ProgBarAttachments: [], GroupAudits: [], ReviewResults: [], Protocol: [], LinkedAudits: []};
  tabinstance: any;
  attachmentlistconfig: ExcListConfig = new ExcListConfig();
  groupAuditListConfig: ExcListConfig = new ExcListConfig();
  linkedAuditListConfig: ExcListConfig = new ExcListConfig();
  stockListConfig: ExcListConfig = new ExcListConfig();
  logListconfig: ExcListConfig = new ExcListConfig();
  progbarBalanceParts: ExcProgbarData[] = [];
  progbarCurrentBalance: ExcProgbarData[] = [];
  indicatorData: ExcIndicatorData[] = [];
  totalClaims = 0;
  level = 1;
  searchValueInventory: string = null;
  searchValueAttachments: string = null;
  isLoading = true;
  initInventoryLength = 0;

  constructor(private aas: AuditActionService, private excRest: ExcRestService, private datePipe: DatePipe, private currencyPipe: CurrencyPipe,
              private excDss: DefaultSettingsService, private excSec: ExcSigninService, private reportService: ReportService) {
    super();
    const _self = this;
    _self.attachmentlistconfig.selectionMode = 'none';
    _self.attachmentlistconfig.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.attachmentlistconfig.OnSearch = function (searchValue, event?) {
      _self.searchValueAttachments = searchValue || '';
      _self.reloadAttachments();
    };
    _self.attachmentlistconfig.OnPageChanged = (pageNo, event1) => {
      _self.attachmentlistconfig.paging.pagingPage = pageNo;
      _self.reloadAttachments();
    };
    _self.attachmentlistconfig.OnRefresh = () => {
      _self.reloadAttachments();
    };
    _self.attachmentlistconfig.OnDetailLink = (item, event?) => {
      // new ExcTab(item.DealerName, DealerDetailsComponent, item, item.DealerID, {
      //   Unique: true, ReloadParent: function () {
      //     // _self.initialLoad();
      //   }
      // }, true).Open();
    };
    _self.groupAuditListConfig.selectionMode = 'none';
    _self.groupAuditListConfig.OnDetailLink = (item, event?) => {
      new ExcTab(item.DealerName, AuditDetailsComponent, item, item.AuditID, {
        Unique: true, ReloadParent: function () {
          // _self.initialLoad();
        }
      }, true).Open();
    };
    _self.linkedAuditListConfig.selectionMode = 'none';
    _self.linkedAuditListConfig.OnDetailLink = (item, event?) => {
      new ExcTab(_self.data.Header['DealerName'] + ' - ' + item.AuditID, AuditDetailsComponent, item, item.AuditID, {
        Unique: true, ReloadParent: function () {
          // _self.initialLoad();
        }
      }, true).Open();
    };
    _self.stockListConfig.selectionMode = 'none';
    _self.stockListConfig.paging = {pagingTotalRows: 1, pagingTotalPages: 1, pagingPage: 1, pagingPageSize: 10};
    _self.stockListConfig.OnSearch = function (searchValue, event?) {
      _self.searchValueInventory = searchValue || '';
      _self.reloadInventory();
    };
    _self.stockListConfig.OnPageChanged = (pageNo, event1) => {
      _self.stockListConfig.paging.pagingPage = pageNo;
      _self.reloadInventory();
    };
    _self.stockListConfig.OnRefresh = () => {
      _self.reloadInventory();
    };
  }
  getHeaderTitle() {
    let t = '';
    if (this.data.Header['AuditType'] === 16 || this.data.Header['AuditType'] === 33 || this.data.Header['AuditType'] === 34 || this.data.Header['AuditType'] === 35) {
      t = this.getGlobal('DigitalAudit');
    } else {
      t = this.getGlobal('PhysicalAudit');
    }
    t = t + ' (' + this.getGlobal('AuditType_' + this.data.Header['AuditType']) + ') - ' + this.data.Header['AuditID'];
    return t;
  }
  openStock(e) {
    const _self = this;
    new ExcTab(this.data.Header['DealerName'] + ' - ' + this.data.Header['AuditID'], AuditReviewComponent, this.data.Header, this.data.Header['AuditID'] + '-Bestand' , {
      Unique: true, ReloadParent: function () { _self.partialLoad(); }
    }, true).Open();
    this.hideMenuPopup(e);
  }
  getDate(x, fmt = 'FormatDate')  {
    if (x === undefined || x === null) {
      return '';
    }
    return this.datePipe.transform(x, this.getGlobal(fmt));
  }
  ngOnInit() {
    this.initialLoad();
  }
  getResultClass(r) {
    if (r.IsFinding === true) {
      if (r.IsCritical === true) {
        return 'th-danger';
      } else {
        return 'th-warning';
      }
    } else {
      return 'th-secondary';
    }
  }
  getReviewResultClass(r) {
    if (r.Code === null) {
      return 'th-secondary';
    }
    if (r.IsOk === true) {
        return 'th-success';
    } else {
      if (r.IsCritical === true) {
        return 'th-danger';
      } else {
        return 'th-warning';
      }
    }
  }
  getProgbarData(container: string) {
    const x: ExcProgbarData[] = [];
    if (this.data[container]['Open']) {
      x.push(new ExcProgbarData(this.data[container]['Open'], this.getGlobal('Open'), '#1b477f', 'white', 'text', []));
    }
    if (this.data[container]['Ok']) {
      x.push(new ExcProgbarData(this.data[container]['Ok'], this.getGlobal('CheckedOk'), '#449d44', 'white', 'text', []));
    }
    if (this.data[container]['NOk']) {
      x.push(new ExcProgbarData(this.data[container]['NOk'], this.getGlobal('CheckedNOk'), '#F49306', 'white', 'text', []));
    }
    if (this.data[container]['Critical']) {
      x.push(new ExcProgbarData(this.data[container]['Critical'], this.getGlobal('CheckedCritical'), '#c9302c', 'white', 'text', []));
    }
    return x;
  }
  closeReview() {
    const _self = this;
    _self.menuPopup.hide();
    const url = _self.excRest.computeUrl('ReviewBalanceR_Summary', {AuditID: this.Data['AuditID']});
    _self.excRest.get(url, {}).subscribe(balance => {
      ExcCoreModule.showModal(ModalReviewFinsihComponent, null, 'xxl', {Balance: balance.Balance, AutoScoring: (balance.AutoScoring || null)}, false, null).subscribe( ret => {
        if (ret && ret.proceed === true) {
          _self.closeReviewAPI(ret.ReviewRating , ret.Comment);
        }
      });
    });
  }
  closeReviewAPI(ratingSelected?: string , Comment?: string) {
    const _self = this;
    const url = _self.excRest.computeUrl('ReviewU_Finish', {AuditID: _self.Data.AuditID });
      _self.excRest.post(url, {ReviewRating: ratingSelected, ReviewUPT: null , Comment: Comment}, {}).subscribe(ret => {
          this.initialLoad();
    });
  }
  reloadAttachments() {
    const _self = this;
    const url = _self.excRest.computeUrl('AuditAttachmentR_List', {AuditID: this.Data.AuditID, fts: this.searchValueAttachments == null ? '' : this.searchValueAttachments});
    const mi = this.attachmentlistconfig.GetMetaInfo();
    _self.attachmentlistconfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.data.Attachments = ret.data;
        _self.attachmentlistconfig.paging = ret.paging;
        _self.attachmentlistconfig.isLoading = false;
      }
    });
  }
  partialLoad() {
    const _self = this;
    const url = _self.excRest.computeUrl('AuditR_Summary', {AuditID: this.Data.AuditID});
    _self.attachmentlistconfig.isLoading = true;
    _self.excRest.get(url, {}).subscribe(ret => {
      if (ret) {
        _self.data['Header'] = ret.data['Header'];
        _self.data['Protocol'] = ret.data['Protocol'];
        // _self.attachmentlistconfig.paging = ret.paging.Attachments;
        // _self.attachmentlistconfig.isLoading = false;
      }
    });
  }
  initialLoad () {
    const _self = this;
    const url = _self.excRest.computeUrl('AuditR_Summary', {AuditID: this.Data.AuditID});

    _self.attachmentlistconfig.isLoading = true;
    try {
      _self.stockListConfig.isLoading = true;
    } catch {
    }
    _self.excRest.get(url, {}).subscribe(ret => {
      if (ret) {
        _self.data = ret.data;
        _self.attachmentlistconfig.paging = ret.paging.Attachments;
        _self.attachmentlistconfig.isLoading = false;
        _self.stockListConfig.isLoading = false;
        _self.stockListConfig.paging = ret.paging.Inventory;
        if (_self.initInventoryLength !== ret.data.Inventory.length) {
          _self.initInventoryLength = ret.data.Inventory.length;
        }
        _self.isLoading = false;
        for (const a of _self.data.GroupAudits) {
            const att: ExcProgbarData[] = [];
            att.push(new ExcProgbarData(a.AttachmentsOpen, this.getGlobal('Open'), '#1b477f', 'white', 'text', []));
            att.push(new ExcProgbarData(a.AttachmentsOk, this.getGlobal('CheckedOk'), '#449d44', 'white', 'text', []));
            att.push(new ExcProgbarData(a.AttachmentsNotOk, this.getGlobal('CheckedNOk'), '#c9302c', 'white', 'text', []));
          a['ProgBarAttachments'] = att;

          const rev: ExcProgbarData[] = [];
          rev.push(new ExcProgbarData(a.InventoryIsNotCleared, this.getGlobal('Open'), '#1b477f', 'white', 'text', []));
          rev.push(new ExcProgbarData(a.InventoryClearedOk, this.getGlobal('CheckedOk'), '#449d44', 'white', 'text', []));
          rev.push(new ExcProgbarData(a.InventoryClearedNotOk, this.getGlobal('CheckedNOk'), '#F49306', 'white', 'text', []));
          rev.push(new ExcProgbarData(a.InventoryClearedCritical, this.getGlobal('CheckedCritical'), '#c9302c', 'white', 'text', []));
          a['ProgBarReview'] = rev;

        }
      }
    });
  }
  reloadInventory() {
    const _self = this;
    const url = _self.excRest.computeUrl('AuditInventoryR_List', {AuditID: this.Data.AuditID, fts: this.searchValueInventory == null ? '' : this.searchValueInventory});
    const mi = this.stockListConfig.GetMetaInfo();
    mi.dataSort = {InventoryVin: 'asc'};
    _self.stockListConfig.isLoading = true;
    _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
      if (ret) {
        _self.data.Inventory = ret.data;
        _self.stockListConfig.paging = ret.paging;
        _self.stockListConfig.isLoading = false;
      }
    });
  }
  cancelAudit() {
    const _self = this;
      ExcCoreModule.showModal(ClientModalAuditCancelComponent, null, 'm', {}, false, null).subscribe( ret => {
        if (ret.proceed === true) {
          const postUrl = _self.excRest.computeUrl('AuditU_Cancel', {AuditID: _self.data.Header['AuditID']});
          _self.excRest.post(postUrl, {
              CancellationReason: ret.CancellationReason,
              Comment: ret.Comment,
              AuditUPT: _self.data.Header['AuditUPT']
            }, {})
            .subscribe(ans => {
              _self.initialLoad();
              if (_self.tabinstance.Config.ReloadParent) {
                _self.tabinstance.Config.ReloadParent();
              }
            });
      }
      });
  }
  auditAction(action) {
    const _self = this;
    switch (action) {
      case 'comment':
        this.aas.SelfcheckComment(_self.data.Header['AuditID'], _self.data.Header['AuditScComment']).subscribe(ret => {
          if (ret.Result === true) {
            Object.assign(_self.data.Header, ret.Data);
          }
        });
        break;
      case 'AuditMdtComment':
        this.aas.AuditMdtComment(_self.data.Header['AuditID'], _self.data.Header['AuditMdtComment']).subscribe(ret => {
          if (ret.Result === true) {
            Object.assign(_self.data.Header, ret.Data);
          }
        });
        break;
      case 'cancel':
        this.aas.Cancel(_self.data.Header['AuditID']).subscribe(ret => { if (ret.Result === true) { _self.initialLoad(); }});
        break;
      case 'pin':
        this.aas.ChangePin(_self.data.Header['AuditID']).subscribe(r => {});
        break;
      case 'extend':
        this.aas.Extend(_self.data.Header['AuditID']).subscribe(ret => { if (ret.Result === true) { _self.initialLoad(); }});
        break;
      case 'resend':
        this.aas.ResendCode(_self.data.Header['AuditID'], _self.data.Header['DealerMail']).subscribe(ret => {});
        break;
      case 'remoteclose':
        this.aas.RemoteClose(_self.data.Header['AuditID'], _self.data.Header['ScItemsDone'], _self.data.Header['ScItemsTotal']).subscribe(ret => { _self.initialLoad(); });
        break;
      default:
        break;
    }
  }

  getAuditReport(e) {
    const url = this.excRest.computeUrl('AuditR_Report', {AuditID: this.Data.AuditID});
    window.open(url, '_blank');
    this.hideMenuPopup(e);
  }
  getInventoryReport(e) {
    const _self = this;
    const url = this.excRest.computeUrl('AuditInventoryR_Export', {AuditID: _self.Data.AuditID, cult: _self.translateService.currentLang});
    window.open(url, '_blank');
    _self.hideMenuPopup(e);
  }
  showMenuPopup(event) {
    this.menuPopup.show(event);
  }
  hideMenuPopup(event) {
    this.menuPopup.hide(event);
  }
  AuditCanCancel() {
    // if (this.data.Header['AuditType'] === 16 && this.data.Header['ScCanEdit'] === true) {
    if (!this.excSec.isFeatured('CLI_ADT_D')) {
      return false;
    }
    if ((this.data.Header.AuditState === 1 && this.data.Header.AuditType !== 16) || (this.data.Header.AuditState < 4 && this.data.Header.AuditType === 16)) {
      return true;
    }
    return false;
  }
  AuditCanEdit() {
    if (!this.excSec.isFeatured('CLI_ADT_U')) {
      return false;
    }
    if ((this.data.Header['AuditType'] === 16 || this.data.Header['AuditType'] === 35) && this.data.Header['auftr_status'] < 8) {
      return true;
    } else if (this.data.Header['AuditType'] !== 16 && this.data.Header['AuditState'] === 1) {
      return false; // return true;
    }
    return false;
  }
  getHistoryMoveJson(data) {
    const arr = [];

    const x = JSON.parse(data.protParamText);
    if (x['OldAnn'] === null) {
      arr.push(this.getTranslation('Globals.AuditHistoryInfoLines.MOVE_FromNoAnn', x));
    } else {
      arr.push(this.getTranslation('Globals.AuditHistoryInfoLines.MOVE_From', x));
    }
    if (x['NewAnn'] === null) {
      arr.push(this.getTranslation('Globals.AuditHistoryInfoLines.MOVE_ToNoAnn', x));
    } else {
      arr.push(this.getTranslation('Globals.AuditHistoryInfoLines.MOVE_To', x));
    }
    if (x['Comment'] !== null) {
      arr.push(this.getTranslation('Globals.AuditHistoryInfoLines.MOVE_Comment', x));
    }

    return arr;
  }
  editAudit() {
    const _self = this;
    this.aas.Edit(this.data.Header['AuditID'], this.data.Header).subscribe(ret => {
      // Object.assign(this.data.Header, ret);
      this.ngOnInit();
    });
  }
  showReports(event) {
    const _self = this;
    _self.menuPopup.hide(event);
    _self.reportService.ShowModal('Audit', _self.data.Header['AuditID']).subscribe(x => {});
  }

  upload(e: ExcFileItem[]) {
    const _self = this;
    const file: ExcFileItem = e[0];
    const url = _self.excRest.computeUrl('AuditU_SetInventory', {AuditID: _self.data.Header['AuditID']});
    ExcCoreModule.showModal(DataImportUploadConfirmModalComponent, null, 's', file.fullName, false, null).subscribe( dlg => {
      if (dlg && dlg.proceed === true) {
        const formData = new FormData();
        formData.append('file[]', file.asBlob, file.fullName);
        _self.excRest.put(url, formData, {}).subscribe(ret => {
          if (ret.success) {
            _self.ngOnInit();
          }
        });
      } else {
        e = [];
      }
    });
  }

  getEnumerationStornoGrund(): any[] {
    return this.excDss.Enumeration.filter((enm: any) => enm.enmName === 'enum_Stornogrund');
  }

  getStornoGrund(Auftr_StornoGrund: any) {
    const stornoArray = this.getEnumerationStornoGrund();
    const stornoGrundElement = stornoArray.find((stornoElement: any) => stornoElement.enmIdent == Auftr_StornoGrund);
    if (stornoGrundElement) {
      return this.translateService.currentLang === 'en' ? stornoGrundElement.enmTextEN : stornoGrundElement.enmText;
    }
    return '';
  }
}
